"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ManualField_1 = require("../ManualField");
function select(params) {
    return new ManualField_1.default(Object.assign({ defaultValue: null }, params));
}
exports.default = select;
